import CallLogIcon from '@/components/icons/navigations/CallLogIcon.vue'
import WhitelistIcon from '@/components/icons/navigations/WhitelistIcon.vue'
import LogoutIcon from '@/components/icons/navigations/LogoutIcon.vue'
import UrlBinding from '@/components/icons/navigations/UrlBinding.vue'
import TrunkIcon from '@/components/icons/navigations/TrunkIcon.vue'

import { ROUTES } from '@/constants/routes'
import { NAVIGATION_ACTIONS } from '@/constants/navigationActions'

export const MENU_ROUTES = [
    {
        id: 1,
        name: 'Call Log',
        routeName: ROUTES.callLog,
        icon: () => CallLogIcon,
    },
    {
        id: 2,
        name: 'Whitelist',
        routeName: ROUTES.whitelist,
        icon: () => WhitelistIcon,
    },
    {
        id: 3,
        name: 'Url Binding',
        routeName: ROUTES.urlBinding,
        icon: () => UrlBinding,
    },
    {
        id: 4,
        name: 'Trunks',
        routeName: ROUTES.trunks,
        icon: () => TrunkIcon,
    },
]

export const BOTTOM_MENU_ROUTES = [
    {
        id: 15,
        name: 'Logout',
        action: NAVIGATION_ACTIONS.logout,
        icon: () => LogoutIcon,
    },
]
